
/* injects from baggage-loader */

'use strict';

import StageTwoComponent from './stage-two.component';

const stageTwoPageModule = angular.module('stage-two-module', [
	'ui.router'
])
	.config($stateProvider => {
		'ngInject';

		$stateProvider
			.state('stages.stage-two', {
				url: '/stage-two',
				views:{
					"@":{
						component: 'stageTwo'
					}
				}
			});
	})
	.component('stageTwo', new StageTwoComponent());

export default stageTwoPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/stage-two/stage-two.module.js